import { cn } from "@newxsystems/shared";
import { WohaCardLink } from "../WohaCardLink/WohaCardLink";
import { WohaMedia } from "../WohaMedia/WohaMedia";
import { WohaRichText } from "../WohaRichText/WohaRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";
const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;
export const ImageContentGridBottom = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => (
  <div className={cn("grid grid-cols-1 gap-6 sm:grid-cols-2", columns[columnCount || 3])}>
    {items.map((item, index) => (
      <WohaCardLink
        className="flex flex-col overflow-hidden rounded-2xl border-0 bg-paper-mist hover:translate-y-0"
        key={index}
        link={item.cardLink}
      >
        <div className="flex-1 p-7 md:p-10">
          <h3 className="font-satoshi text-3xl font-medium leading-tight text-charcoal transition-colors group-hover:text-electric-blue">
            {item.heading}
          </h3>
          {item.description ? (
            <WohaRichText
              className="mt-4 text-base leading-7 text-steel"
              content={item.description}
            />
          ) : null}
        </div>
        <WohaMedia
          aspectRatio={imageAspectRatio || "16:9"}
          className="rounded-none border-0"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
      </WohaCardLink>
    ))}
  </div>
);
ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
